import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { TemplateModule } from 'src/app/template/template.module';

import { GenderSelectorComponent } from './components/gender-selector/gender-selector.component';

import { GenderService } from './services/gender.service';

@NgModule({

    declarations: [
        GenderSelectorComponent
    ],

    imports: [
        CommonModule,
        SharedModule,
        TemplateModule
    ],

    exports: [
        GenderSelectorComponent
    ],

    providers: [
        GenderService
    ]

})
export class GendersModule { }
